import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { IProductDetails } from '@alycecom/ui';

const PREFIX = 'PRODUCT/DETAILS';

export const loadProductDetailsRequest = createAction<{ hashId: string; productId: number }>(
  `${PREFIX}/LOAD_PRODUCT_DETAILS_REQUEST`,
);
export const loadProductDetailsSuccess = createAction<IProductDetails>(`${PREFIX}/LOAD_PRODUCT_DETAILS_SUCCESS`);
export const loadProductDetailsFail = createAction<TLegacyErrors>(`${PREFIX}/LOAD_PRODUCT_DETAILS_FAIL`);
export const resetProductDetails = createAction<void>(`${PREFIX}/RESET_PRODUCT_DETAILS`);
